import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { XmlDataset } from 'app/model/dataset/xml.dataset';
import { Metamodel } from 'app/model/base/model';
import { FormatTypeCopySource } from './format-type.copysource';

@Metamodel.model({
    name: adfModelTypeMap.xml.copySourceType,
    display: [],
    tags: { datasetModel : [Metamodel.modelFor(XmlDataset)]}
})
export class XmlCopySource extends FormatTypeCopySource {
}
